import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import img54 from "../../assets/newimg/logo.png";
import { isBrowser, isMobile } from "react-device-detect";
import {
  TextField,
  Typography,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  MenuItem,
  Select,
  Button,
  Modal,
  Box,
} from "@mui/material";
import oracle from "../../assets/traffic_monster/oracle.png";
import hp from "../../assets/traffic_monster/hp.png";
import honda from "../../assets/traffic_monster/honda.png";
import american_red_cross from "../../assets/traffic_monster/american_red_cross.png";
import nv_energy from "../../assets/traffic_monster/nv_energy.png";
import avery_dennison from "../../assets/traffic_monster/avery_dennison.png";
import corning from "../../assets/traffic_monster/corning.png";
import "../traffic_monster/generated_blogs.css";
import testimonialImg1 from "../../assets/traffic_monster/testimonialImg1.png";
import testimonialImg3 from "../../assets/traffic_monster/testimonialImg3.png";
import testimonialImg4 from "../../assets/traffic_monster/testimonialImg4.jpg";
import {
  useGetgeneratedBlogListingsQuery,
  useGetrandomBlogListingsQuery,
} from "../../redux/api/promptApi";
import common_bg from "../../assets/podcast_monster/common_bg.png";
import { useGenerateBusinessBlogMutation } from "../../redux/api/promptApi";
import { toast } from "react-toastify";
import axios from "axios";
import sectionbg from "../../assets/ocesha_images/landing_new/hero2.png";
import section8 from "../../assets/ocesha_images/Ocesha8Section.png";
import OceShaActionSection from "./OceShaActionSection";
import OceShaIdeaSection from "./OceShaIdeaSection";


import {
  CreditCardOutlined,
  CampaignOutlined,
  DescriptionOutlined,
  ReplyOutlined,
  SmartToyOutlined,
  PublicOutlined,
  SchoolOutlined,
} from "@mui/icons-material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import ocesha_logo from "../../assets/ocesha_images/ocesha_logo.png";
import "../style.css";
import Header from "../auth/Header";
import backgroundimage from "../../assets/ocesha_images/backgroundimage.png";
import CourseCreatorHero from "../../components/CourseCreatorHero";
import Section2 from "../../components/Section2";
import Section3 from "../../components/OceShaSection3";
import Section5 from "../../components/OceShaSection5";
import Section6 from "../../components/OceShaSection6";
import SectionFaq from "../../components/OceShaFaq";
import SectionTest from "../../components/OceShaTestimonials";
import OceShaCreatorTestimonials from "components/OceShaCreatorTestimonials";
import OceShaDemoSection from "./OceShaDemoSection";
import OceShaFlowSection from "./OceShaFlowSection";
import OceShaTestimonials from "./OceShaTestimonials";
import TrustedOrganizations from "./Trustedorganizations";


const section1 = `${process.env.PUBLIC_URL}/Ocesha2Section.png`;
const section2 = `${process.env.PUBLIC_URL}/Ocesha3Section.png`;
const section3 = `${process.env.PUBLIC_URL}/Ocesha9Section.png`;
const section4 = `${process.env.PUBLIC_URL}/Ocesha4Section.png`;
const section6 = `${process.env.PUBLIC_URL}/Ocesha6Section.png`;
const section7 = `${process.env.PUBLIC_URL}/Ocesha7Section.png`;
const apiUrl = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

const OceshaLandingNew = () => {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentIndexTextTesti, setCurrentIndexTextTesti] = useState(0);
  const [isWideScreen, setIsWideScreen] = useState(false);
  const [isIpadMini, setIsIpadMini] = useState(false);
  const [randomInteger, setRandomInteger] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [blogs, setBlogs] = useState<any>();
  const [randomBlogs, setRandomBlogs] = useState<any>();
  const [httpsVal, setHttpsVal] = useState("https://");
  const [businessBlogMutation] = useGenerateBusinessBlogMutation();
  const [otherOption, setOtherOption] = useState(false);
  const [uploadVideo, setUploadVideo] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedvideopath, setUploadedvideopath] = useState("");
  const [arrowClick1, setArrowClick1] = useState<any>();
  const [arrowClick2, setArrowClick2] = useState<any>();
  const [arrowClick3, setArrowClick3] = useState<any>();
  const [urlPrefix, setUrlPrefix] = useState<string>(
    /* 'https://' */ "youtubeid",
  );
  const [businessUrl, setBusinessUrl] = useState("");
  const [userBusinessText, setUserBusinessText] = useState("");
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [isScrapcheckloading, setIsScrapcheckloading] =
    useState<boolean>(false);
  const [contactname, setContactName] = useState<any>();
  const [contactemail, setContactEmail] = useState<any>();
  const [contactPhno, setContactPhNo] = useState<any>();
  const [contactMessage, setContactMessage] = useState<any>();
  const [isContacting, setIsContacting] = useState<boolean>(false);
  const [helpervideosrc, setHelperVideoSrc] = useState<any>();
  const [helperPopup, setHelperPopup] = useState<boolean>(false);
  const [zoomLevel, setZoomLevel] = useState(
    Math.round((window.outerWidth / window.innerWidth) * 100),
  );

  const sections = useRef<(HTMLDivElement | null)[]>([]);

  /*** code for celery starts */
  interface TaskStatusResponse {
    state: "pending" | "done" | "error";
    result?: any;
    message?: string;
  }

  interface ScrapPageResponse {
    task_id: string;
  }

  // Utility to sleep for some ms
  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  const waitForTaskResult = async (
    taskId: string,
    apiUrl: string,
  ): Promise<any> => {
    const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;

    while (true) {
      const { data } = await axios.get<TaskStatusResponse>(statusUrl);

      if (data.state === "done") {
        return data.result;
      } else if (data.state === "error") {
        throw new Error(data.message || "Task failed");
      }

      await sleep(2000); // poll every 2 seconds
    }
  };

  /*** code for celery ends */

  useEffect(() => {
    const handleResize = () => {
      setZoomLevel(Math.round((window.outerWidth / window.innerWidth) * 100));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const observerOptions = {
  //     threshold: 0.2, // threshold based on when want the animation to trigger
  //   };

  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add("visible"); // Add 'visible' class when in view
  //       } else {
  //         entry.target.classList.remove("visible"); // Remove class when out of view
  //       }
  //     });
  //   }, observerOptions);

  //   sections.current.forEach((section) => {
  //     if (section instanceof Element) {
  //       observer.observe(section);
  //     }
  //   });

  //   return () => {
  //     sections.current.forEach((section) => {
  //       if (section instanceof Element) {
  //         observer.unobserve(section);
  //       }
  //     });
  //   };
  // }, []);

  const promptid = params.get("promptid") ?? "";

  const videotestimonialData = [
    {
      // image: testimonial_videoImg1,
      video: "https://www.youtube.com/embed/mEyC24nC73k",
      name: "Jay Levin",
      title: "CEO Equip Our Kids LA Weekly Magazine",
    },
    {
      // image: testimonial_videoImg2,
      video: "https://www.youtube.com/embed/bQ694TD-QCE",
      name: "Giovanni Villa",
      title: "CEO Bella2Bello",
    },
    {
      // image: testimonial_videoImg2,
      video: "https://www.youtube.com/embed/KLLaclzl5r0",
      name: "Paul Claxton",
      title: "Managing General Partner",
    },
  ];
  const testimonialCount = videotestimonialData.length;
  /* video testimonial */
  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 3 + testimonialCount) % testimonialCount,
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 3) % testimonialCount);
  };

  const getDisplayedTestimonials = () => {
    let displayedTestimonials = [];
    for (let i = 0; i < 3; i++) {
      displayedTestimonials.push(
        videotestimonialData[(currentIndex + i) % testimonialCount],
      );
    }
    return displayedTestimonials;
  };

  const handlePrevMob = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNextMob = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === videotestimonialData.length - 1
        ? 0
        : isMobile
          ? prevIndex + 1
          : 0,
    );
  };

  /*  */

  /* 1366x768 resolution for the section(what if you had 1000 AI agents.) */
  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth <= 1366 && window.innerHeight <= 768);
      setIsIpadMini(window.innerWidth <= 1024 && window.innerHeight <= 768);
    };

    handleResize(); // Initial call
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /*  */

  /* Text testimonial */
  const testimonialtoshow = isMobile ? 1 : 3;

  var testimonialsettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: testimonialtoshow,
    slidesToScroll: 1,
    arrows: true,
  };
  const testimonials = [
    {
      name: "CRAIG SHAH/CEO",
      icon: (
        <img
          src={testimonialImg4}
          className="img-fluid rounded-circle twitter-padding"
          alt=""
          width="49"
          height="44"
        ></img>
      ),
      content: "Amazing!",
      reference: "EVOKE",
    },
    {
      name: "KURT KUMAR/CEO",
      icon: (
        <img
          src={testimonialImg3}
          className="img-fluid rounded-circle twitter-padding"
          alt=""
          width="49"
          height="44"
        ></img>
      ),
      content:
        "Traffic Monster solves a problem that every business encounters.  How do you get traffic and leads and ultimately sales to your business.",
      reference: "SAPX",
    },
    {
      name: "JAMAL WOODLEY/CEO",
      icon: (
        <img
          src={testimonialImg1}
          className="img-fluid rounded-circle twitter-padding"
          alt=""
          width="49"
          height="44"
        ></img>
      ),
      content:
        "It's very impressive.  I think this is something that every entrepreneur will be excited about..",
      reference: "MINDMADE BRANDS",
    },
  ];
  const testimonialCount1 = testimonials.length;

  const handlePrevTextTesti = () => {
    setCurrentIndexTextTesti(
      (prevIndex) => (prevIndex - 1 + testimonialCount1) % testimonialCount1,
    );
  };

  const handleNextTextTesti = () => {
    setCurrentIndexTextTesti(
      (prevIndex) => (prevIndex + 1) % testimonialCount1,
    );
  };

  const getDisplayedTestimonials1 = () => {
    let displayedTestimonials = [];
    for (let i = 0; i < 3; i++) {
      displayedTestimonials.push(
        testimonials[(currentIndexTextTesti + i) % testimonialCount1],
      );
    }
    return displayedTestimonials;
  };
  /*  */

  useEffect(() => {
    // Calculate random integer when totalPages is available
    if (totalPages !== null) {
      const min = 1;
      const max = totalPages;
      const randomInteger = Math.floor(Math.random() * (max - min + 1)) + min;
      setRandomInteger(randomInteger);
    }
  }, [totalPages]);

  /* News portion Blogs */
  const supportEmail: string = process.env.REACT_APP_SUPPORT_EMAIL || "";
  const getBlogs = useGetgeneratedBlogListingsQuery({
    promptid: "" /* promptid */,
    userid: "" /* supportEmail */,
    limitval: 3,
    skipval: randomInteger,
  });

  useEffect(() => {
    if (getBlogs.data) {
      setBlogs([...getBlogs.data]);
    }
  }, [getBlogs]);
  /*  */

  /* random customer blogs */
  const getRandomBlogs = useGetrandomBlogListingsQuery({});

  useEffect(() => {
    if (getRandomBlogs.data) {
      setRandomBlogs([...getRandomBlogs.data]);
    }
  }, [getRandomBlogs]);
  /*  */

  // const domain = window.location.hostname;
  const handleReadMoreClick = (userid: any) => {
    window.open(`/blogs?userid=${userid}`, "_blank");
  };

  const supportUserid = process.env.REACT_APP_SUPPORT_USER_ID || "";

  const handleStartFreeClick = () => {
    // localStorage.setItem("CreatingfromLanding", "true");
    // localStorage.setItem("course_creation_topic", "");
    // localStorage.setItem("uploadedText", "");
    // navigate("/signup", { state: { DirectFreeSignup: "true" } });

    const queryParams = new URLSearchParams({
        FromSignUp: "true",
        CreatingfromLanding: "true",
        course_creation_topic: "",
        uploadedText: "",
      });

      window.location.href = `${apiUrl}/signup?${queryParams.toString()}`;
      return;
  };

  const handleUnload = () => {
    localStorage.removeItem("CreatingfromLanding");
    localStorage.removeItem("UrlfromLanding");
    localStorage.removeItem("user_pass");
    localStorage.removeItem("user_name");
    // localStorage.removeItem('user_email');
  };
  window.addEventListener("beforeunload", handleUnload);

  useEffect(() => {
    localStorage.removeItem("CreatingfromLanding");
    localStorage.removeItem("UrlfromLanding");
    localStorage.removeItem("user_pass");
    localStorage.removeItem("user_name");
    // localStorage.removeItem('user_email');
  }, []);

  const clearCookies = () => {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name] = cookie.split("=");
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
    }
  };

  const clearLocalStorage = () => {
    const keysToRemove = [
      "msg",
      "complexity",
      "module",
      "subscription_level",
      "free_plan",
      "localStorage_msg",
      "allSet",
      "Blogs Generated",
      "remaining_wish_count",
      "userRole",
      "payment",
      "user_email",
      "logged_in",
      "prevImg",
      "fromUpgrade",
      "blogsCount",
      "Generating Count",
      "finalData",
      "user_pass",
      "fromNewcampaign",
      "campaignid",
      "returningtocampaign",
      "sourceurl",
      "campaignName",
      "paymentOption",
      "autoPublish",
      "limitPublish",
      "campId",
      "smUrlpublish",
      "addTags",
      "captureLeads",
      "newsLetter",
      "twitterBtn",
      "fbBtn",
      "pintrestBtn",
      "linkedinBtn",
      "video",
      "twitterurl",
      "fburl",
      "pintresturl",
      "linkedinurl",
      "owndomain",
      "ChangepayMode",
      "IdChangingMode",
      "user_name",
      "refreshCount",
      "publishingCampId",
      "Authorurl",
      "Authorname",
      "authorDefaultCheck",
      "appsumo_coupon_code",
      "podcastUrl",
      "AlertMessage",
      "CreatingfromLanding",
      "UrlfromLanding",
      "signedup",
      "uploadedvideo",
      "uploadedVideoName",
      "uploadStatus",
    ];
    keysToRemove.forEach((key) => localStorage.removeItem(key));
  };

  const handleGenerateBlogClick = async (
    url: string,
    userid: string,
    uploadedtext: string,
    youtubeUrl: any,
  ) => {
    clearCookies();
    localStorage.clear();
    if (url) {
      localStorage.clear();

      /* let youtubeMatch = url.match(
                /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\?.*)?/
            ); */

      // if (youtubeMatch) {
      localStorage.setItem("CreatingfromLanding", "true");
      localStorage.setItem("UrlfromLanding", url);
      if (userid === "") {
        navigate("/signup", {
          state: {
            CreatingfromLanding: localStorage.getItem("CreatingfromLanding"),
            UrlfromLanding: localStorage.getItem("UrlfromLanding"),
          },
        });
      }
      /* } else if (!youtubeMatch) {
                toast.error('Please enter valid youtube video url!');
            } */
    } else if (youtubeUrl) {
      const youtubeMatch = youtubeUrl?.match(
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/,
      );

      if (youtubeMatch) {
        localStorage.setItem("CreatingfromLanding", "true");
        localStorage.setItem("YoutubeUrlfromLanding", youtubeUrl);
        if (userid === "") {
          navigate("/signup", {
            state: {
              CreatingfromLanding: localStorage.getItem("CreatingfromLanding"),
              UrlfromLanding: localStorage.getItem("UrlfromLanding"),
              YoutubeUrlfromLanding: localStorage.getItem(
                "YoutubeUrlfromLanding",
              ),
            },
          });
        }
      } else if (!youtubeMatch) {
        toast.error("Somethign went wrong, check your url format.");
      }
    } else if (
      /* localStorage.getItem('uploadStatus') == 'success' && */ userBusinessText
    ) {
      localStorage.setItem("CreatingfromLanding", "true");
      localStorage.setItem("uploadedText", userBusinessText);
      if (userid === "") {
        navigate("/signup", {
          state: {
            CreatingfromLanding: localStorage.getItem("CreatingfromLanding"),
            TextfromLanding:
              localStorage.getItem(
                "uploadedText",
              ) /*  VideofromLanding: localStorage.getItem('uploadedvideo') */,
          },
        });
      }
    } else if (!url || !uploadedtext) {
      toast.error("Please enter your business url/upload text!");
    }
  };

  const handlevideoChange = async (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setUploadVideo(file.name);
      console.log("Uploaded video file:", file);
      const formData = new FormData();
      formData.append("media_file", file);

      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
      setIsLoading(true);
      try {
        const response = await axios.post(
          `${apiUrl}/api/prompts/upload_media_file`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        console.log(response.data.data);
        if (response.data.result === "success" && response.data.data) {
          localStorage.setItem("uploadedVideoName", file.name);
          localStorage.setItem("uploadStatus", "success");
          setUploadedvideopath(response.data.data);
          toast.success("File Uploaded Successfully!");

          localStorage.setItem("CreatingfromLanding", "true");
          localStorage.setItem("uploadedvideo", response.data.data);
          // if (localStorage.getItem('user_email') === '') {
          navigate("/signup", {
            state: {
              CreatingfromLanding: localStorage.getItem("CreatingfromLanding"),
              VideofromLanding: localStorage.getItem("uploadedvideo"),
              videoNamefromLanding: localStorage.getItem("uploadedVideoName"),
            },
          });
          // }
        } else if (response.data.result === "fail") {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error uploading video:", error);
        toast.error("Error uploading video");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleTextChange = (event: any) => {
    let inputText = event.target.value;
    setUserBusinessText(inputText);
    localStorage.setItem("CreatingfromLanding", "true");
    localStorage.setItem("uploadedText", inputText);
  };

  const handlescrapPage = async (url: string) => {
    setIsScrapcheckloading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

      // const response = await axios.get(
      //     `${apiUrl}/api/prompts/scrap_page?url=${url}`,
      // );

      // Step 1: start the task
      const { data } = await axios.get<ScrapPageResponse>(
        `${apiUrl}/api/prompts/scrap_page?url=${encodeURIComponent(url)}`,
      );
      const taskId = data.task_id;

      // Step 2: poll until done
      const response = await waitForTaskResult(taskId, apiUrl);

      if (response.result === "failed") {
        toast.error(response.data);
      } else {
        handleGenerateBlogClick(
          url,
          localStorage.getItem("user_email") || "",
          userBusinessText,
          youtubeUrl,
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsScrapcheckloading(false);
    }
  };

  const handleUrlPrefixChange = (event: any) => {
    const selectedValue = event.target.value;
    setUrlPrefix(selectedValue);
    console.log("URL Prefix Changed:", selectedValue);
  };

  useEffect(() => {
    console.log("urlPrefix updated:", urlPrefix);
  }, [urlPrefix]);

  const handleGetStartedClick = async () => {
    if (!contactname && !contactemail && !contactPhno && !contactMessage) {
      toast.error("Please fill your details!");
    } else {
      const formData = new FormData();
      formData.append("name", contactname);
      formData.append("email", contactemail);
      formData.append("phone", contactPhno);
      formData.append("subject", contactMessage);
      formData.append("message", contactMessage);
      try {
        setIsContacting(true);
        const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";
        const response = await axios.post(
          apiUrl + "/api/auth/contactus",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setContactName("");
          setContactEmail("");
          setContactPhNo("");
          setContactMessage("");
        } else {
          toast.error("Please try agin later!");
        }
      } catch (error) {
        console.log("Error while contacting", error);
      } finally {
        setIsContacting(false);
      }
    }
  };

  const handlePlayVideo = (videosrc: any) => {
    setHelperVideoSrc(videosrc);
    setHelperPopup(true);
  };
   
  return (
    <>
      <div style={{ backgroundImage: `url(${backgroundimage})`, backgroundSize: "cover" }}>
        <Header />
        
        <div className="container">

          {/* First Section */}
           <div
            ref={(el) => (sections.current[2] = el)}
            style={{
              marginTop: "0px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <div style={{ width: "80%", maxWidth: "1600px", margin: "0 auto" }}>
              {/* Badge */}

              {/* Diagram */}
              <CourseCreatorHero />


              {/* Button */}

              
            </div>
          </div>
          
          {/* Second Section */}
           <div
            ref={(el) => (sections.current[3] = el)}
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <div style={{ width: "80%", maxWidth: "1600px", margin: "0 auto" }}>
              {/* Badge */}

              {/* Diagram */}
              <TrustedOrganizations />


              {/* Button */}

              
            </div>
          </div>
          

          {/* Section 3 — See OceSha in Action */}
          <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <OceShaActionSection
              youtubeUrl="https://www.youtube.com/embed/crbfiYw3WQE?autoplay=1&mute=1&loop=1&playlist=crbfiYw3WQE&rel=0"
            />
          </div>
{/*   */}
        {/* Section 3 — See OceSha in Action */}
          <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <OceShaIdeaSection
              onStartFree={() => {
                  // localStorage.setItem("CreatingfromLanding", "true");
                  // localStorage.setItem("course_creation_topic", "");
                  // localStorage.setItem("uploadedText", "");
                  // navigate("/signup", { state: { DirectFreeSignup: "true" } });
                  const apiUrl: string = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

                  const queryParams = new URLSearchParams({
                      FromSignUp: "true",
                      CreatingfromLanding: "true",
                      course_creation_topic: "",
                      uploadedText: "",
                  });

                  window.location.href = `${apiUrl}/signup?${queryParams.toString()}`;
                  return;
              }}
            />
          </div>


          <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          
          >
            <OceShaCreatorTestimonials 
              onStartFreeClick={() => {
                  // localStorage.setItem("CreatingfromLanding", "true");
                  // localStorage.setItem("course_creation_topic", "");
                  // localStorage.setItem("uploadedText", "");
                  // navigate("/signup", { state: { DirectFreeSignup: "true" } });
                  const apiUrl: string = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

                  const queryParams = new URLSearchParams({
                      FromSignUp: "true",
                      CreatingfromLanding: "true",
                      course_creation_topic: "",
                      uploadedText: "",
                  });

                  window.location.href = `${apiUrl}/signup?${queryParams.toString()}`;
                  return;
              }}
            />
          </div>


           <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          
          >
            <Section5 
              onStartFree={() => {
                  // localStorage.setItem("CreatingfromLanding", "true");
                  // localStorage.setItem("course_creation_topic", "");
                  // localStorage.setItem("uploadedText", "");
                  // navigate("/signup", { state: { DirectFreeSignup: "true" } });
                  const apiUrl: string = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

                  const queryParams = new URLSearchParams({
                      FromSignUp: "true",
                      CreatingfromLanding: "true",
                      course_creation_topic: "",
                      uploadedText: "",
                  });

                  window.location.href = `${apiUrl}/signup?${queryParams.toString()}`;
                  return;
              }}
            />
          </div>

          <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <Section6 
              onStartFree={() => {
                // localStorage.setItem("CreatingfromLanding", "true");
                  // localStorage.setItem("course_creation_topic", "");
                  // localStorage.setItem("uploadedText", "");
                  // navigate("/signup", { state: { DirectFreeSignup: "true" } });
                  const apiUrl: string = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

                  const queryParams = new URLSearchParams({
                      FromSignUp: "true",
                      CreatingfromLanding: "true",
                      course_creation_topic: "",
                      uploadedText: "",
                  });

                  window.location.href = `${apiUrl}/signup?${queryParams.toString()}`;
                  return;
              }}
            />
          </div>

           <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <SectionFaq 
              onStartFreeClick={() => {
                // localStorage.setItem("CreatingfromLanding", "true");
                  // localStorage.setItem("course_creation_topic", "");
                  // localStorage.setItem("uploadedText", "");
                  // navigate("/signup", { state: { DirectFreeSignup: "true" } });
                  const apiUrl: string = process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

                  const queryParams = new URLSearchParams({
                      FromSignUp: "true",
                      CreatingfromLanding: "true",
                      course_creation_topic: "",
                      uploadedText: "",
                  });

                  window.location.href = `${apiUrl}/signup?${queryParams.toString()}`;
                  return;
              }}
            />
          </div>

           <div
            ref={(el) => (sections.current[1] = el)}
            className="section"
            style={{
              marginTop: "40px",
              position: "relative",
              left: "50%",
              right: "50%",
              width: "100vw",
              marginLeft: "-50vw",
              marginRight: "-50vw",
            }}
          >
            <SectionTest 
              onStartFreeClick={() => {
                    const apiUrl =
                      process.env.REACT_APP_RETURN_DOMAIN_NAME || "";

                    const queryParams = new URLSearchParams({
                      FromSignUp: "true",
                      CreatingfromLanding: "true",
                      course_creation_topic: "",
                      uploadedText: "",
                    });

                    const baseUrl = apiUrl.replace(/\/+$/, "");

                    window.location.href =
                      `${baseUrl}/signup?${queryParams.toString()}`;
                  }}
            />
          </div>




 
        </div>
      </div>

      <Modal
        open={helperPopup}
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "70%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: "15px",
            padding: "3%",
          }}
        >
          <iframe
            width="100%"
            height="500"
            src={helpervideosrc}
            title="Help Video"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
          <Stack flexDirection="row">
            <Button
              onClick={() => setHelperPopup(false)}
              variant="contained"
              sx={{ mr: 2, marginTop: "15%" }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default OceshaLandingNew;